// Types
import { SelectedExamCardType } from "src/services/exams/types";

// Constants
import { examCardEnums } from "src/constants/enums";

/**
 * Whether an aniseikonia card has at least one meridian turned on.
 *
 * The webservice rejects an exam whose aniseikonia section measures no meridian, and the whole
 * exam fails with it -- no sections are added at all. Of its four validation refusals this is the
 * only one an ordinary click can reach, so the card blocks it rather than letting the request go
 * out and take the other sections down with it.
 */
export const hasAniseikoniaMeridian = (
  examCard: Pick<SelectedExamCardType, "horizontal" | "vertical" | "overall">
) =>
  Boolean(examCard?.horizontal) ||
  Boolean(examCard?.vertical) ||
  Boolean(examCard?.overall);

/**
 * Whether any card in the slider is an aniseikonia card that would be refused on save.
 *
 * Used to disable the slider's save button, which is the point the request is assembled.
 */
export const hasInvalidAniseikoniaCard = (
  examCards: Array<SelectedExamCardType> | undefined
) =>
  Boolean(
    examCards?.some(
      (examCard) =>
        examCard?.examFieldType === examCardEnums.ANISEIKONIA.algorithmPath &&
        !hasAniseikoniaMeridian(examCard)
    )
  );
